import { createContext } from 'react';
import HasuraUser from './types/user';

type AuthContextType = {
    currentUser: HasuraUser | null
    setCurrentUser:(o: HasuraUser | null) => void
}

export const AuthContext = createContext<AuthContextType>({currentUser: null, setCurrentUser: () => {}});
